import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * Component for displaying title and subtitle
 *
 * on Account Web, many pages have different style of heading
 * e.g. for login and signup vs forgot password and select account
 *
 * TODO:
 * consult with designer whether we could merge them
 * or maybe we could have several heading components
 */

@Component({
  selector: 'app-heading',
  templateUrl: 'heading.component.html',
  styleUrls: ['heading.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeadingComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() hasLessMargin: boolean;

  constructor() {}
}
